<script setup>
    // attempts to sync customers to PMS, just by calling the function under the url.

    import axios from 'axios';
    import Swal from 'sweetalert2';
    import { ref } from 'vue';

    const props = defineProps(['fetchUrl']);
    const isLoading = ref(null);

    // attempts the sync. While that is happening, the icon on the button is spinning and the button disabled
    // in order to not trigger multiple syncs accidentally. When the sync is done, a SweetAlert2 modal pops up.
    function renewMandate() {
        isLoading.value = true;
        axios.put(props.fetchUrl).then((response) => {
            Swal.fire({
                title: "Erfolgreich",
                text: response.data.data.message,
                icon: "success",
            });
            isLoading.value = false;
        }).catch(error => {
            if (error.response) {
                Swal.fire({
                    title: "Fehlgeschlagen",
                    text: error.response.data.data,
                    icon: "error",
                });
            }
        });
    }

</script>

<template>
    <button @click.prevent="renewMandate()" class="btn btn-primary" type="button">
        <i :class="[isLoading ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-users']" :disabled="isLoading"></i> Mandat Erneuern
    </button>
</template>
